<template lang="html">
    <section class="error-404">
        <h1 class="display-1 mb-0 text-center">404</h1>
    </section>
</template>

<script lang="js">
export default {
    name: 'error-404',
};
</script>



// WEBPACK FOOTER //
// src/views/sample-pages/error-404.vue